// Generate URL-friendly slug from text
export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .trim()
    // Replace Hungarian special characters
    .replace(/á/g, 'a')
    .replace(/é/g, 'e')
    .replace(/í/g, 'i')
    .replace(/ó/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/ő/g, 'o')
    .replace(/ú/g, 'u')
    .replace(/ü/g, 'u')
    .replace(/ű/g, 'u')
    // Replace spaces and special characters with hyphens
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Generate project URL slug from project (uses Hungarian title + location without country + order)
export function generateProjectUrl(project: { id: string; title: { hu: string; en: string }; location: string; order?: number } | null): string {
  if (!project || !project.title || !project.location) {
    console.warn('Invalid project passed to generateProjectUrl:', project);
    return 'invalid-project';
  }
  
  const titleSlug = generateSlug(project.title.hu || project.title.en);
  // Remove country from location (everything after comma)
  const locationWithoutCountry = project.location.split(',')[0].trim();
  const locationSlug = generateSlug(locationWithoutCountry);
  const orderNumber = project.order ?? 0;
  return `${titleSlug}-${locationSlug}-${orderNumber}`;
}

// Generate news URL slug from news (uses Hungarian title + ID for uniqueness)
export function generateNewsUrl(news: { id: string; title: { hu: string; en: string }; order?: number } | null): string {
  if (!news || !news.title || !news.id) {
    console.warn('Invalid news passed to generateNewsUrl:', news);
    return 'invalid-news';
  }
  
  const slug = generateSlug(news.title.hu || news.title.en);
  // Use a double underscore separator to avoid UUID confusion
  return `${slug}__${news.id}`;
}

// Extract ID from news slug (returns the part after the double underscore)
export function extractIdFromNewsSlug(slug: string): string {
  // Split by double underscore to get the ID
  const parts = slug.split('__');
  if (parts.length >= 2) {
    return parts[parts.length - 1];
  }
  // Fallback: if no double underscore, return empty string
  return '';
}